import React from 'react';

import { Form } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { Control, Controller } from 'react-hook-form';

import { RelationshipType } from 'models/worker/utils/RelationshipType';

interface IRelationshipControllerProps {
    className?: string;
    name: string;
    control: Control;
    size?: 'sm' | 'lg';
    disabled?: boolean;
}

export const RelationshipController = ({name, control, className, size, disabled}: IRelationshipControllerProps) => {
    const {t} = useTranslation();

    const nextOfKinOptions = React.useMemo(() => {
        return (
            <>
                <option value={RelationshipType.SPOUSE}>
                    {t('nextOfKin.spouse', 'Spouse')}
                </option>
                <option value={RelationshipType.PARTNER}>
                    {t('nextOfKin.partner', 'Partner')}
                </option>
                <option value={RelationshipType.MOTHER}>
                    {t('nextOfKin.mother', 'Mother')}
                </option>
                <option value={RelationshipType.FATHER}>
                    {t('nextOfKin.father', 'Father')}
                </option>
                <option value={RelationshipType.BROTHER}>
                    {t('nextOfKin.brother', 'Brother')}
                </option>
                <option value={RelationshipType.SISTER}>
                    {t('nextOfKin.sister', 'Sister')}
                </option>
                <option value={RelationshipType.SON}>
                    {t('nextOfKin.son', 'Son')}
                </option>
                <option value={RelationshipType.DAUGHTER}>
                    {t('nextOfKin.daughter', 'Daughter')}
                </option>
                <option value={RelationshipType.BOYFRIEND}>
                    {t('nextOfKin.boyfriend', 'Boyfriend')}
                </option>
                <option value={RelationshipType.GIRLFRIEND}>
                    {t('nextOfKin.girlfriend', 'Girlfriend')}
                </option>
                <option value={RelationshipType.SON_IN_LAW}>
                    {t('nextOfKin.sonInLaw', 'Son in Law')}
                </option>
                <option value={RelationshipType.DAUGHTER_IN_LAW}>
                    {t('nextOfKin.daughterInLaw', 'Daughter in Law')}
                </option>
                <option value={RelationshipType.MOTHER_IN_LAW}>
                    {t('nextOfKin.motherInLaw', 'Mother in Law')}
                </option>
                <option value={RelationshipType.FATHER_IN_LAW}>
                    {t('nextOfKin.fatherInLaw', 'Father in Law')}
                </option>
                <option value={RelationshipType.OTHER}>
                    {t('nextOfKin.other', 'Other')}
                </option>
                <option value={RelationshipType.DOCTOR}>
                    {t('nextOfKin.doctor', 'Doctor')}
                </option>
            </>
        );
    }, [t]);

    return (
        <Controller
            name={name}
            control={control}
            render={(
                {onChange, onBlur, value, ref, name: controllerName},
                {invalid}
            ) => (
                <Form.Control
                    custom
                    as="select"
                    className={className}
                    name={controllerName}
                    onChange={(e) => onChange(e.target.value as RelationshipType)}
                    defaultValue={value}
                    onBlur={onBlur}
                    ref={ref}
                    isInvalid={invalid}
                    size={size}
                    disabled={disabled}
                >
                    <option value="">
                        {t('common.select', 'Select')}
                    </option>
                    {nextOfKinOptions}
                </Form.Control>
            )}
        />
    );
};
